import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuidv4 from 'uuid/v4';

import {
  Display,
  Header,
  Content,
  HardwareButtonWrapper
} from 'containers';

import { Icon } from 'components';
import { DisplayButton } from 'components/buttons';

import styles from './MainEngineNotStarted.scss';

const MainEngineNotStarted = ({ values }) => [
  <Display key="display">
    <Header buttonContainer noMargin>
      <DisplayButton src="icon-xm-settings" />
      <DisplayButton src="icon-xm-p" />
      <DisplayButton src="icon-xm-n" />
      <DisplayButton src="icon-xm-person" />
    </Header>
    <Content>
      <div className={styles.content}>
        {values.length > 0 &&
          values.map(item => (
            <Icon
              key={uuidv4()}
              src={item.icon}
              value={item.value}
              noBorder={!item.value}
            />))
        }
      </div>
    </Content>
  </Display>,
  <HardwareButtonWrapper key="buttons" config={{}} />
];

MainEngineNotStarted.defaultProps = {
  values: []
};

MainEngineNotStarted.propTypes = {
  values: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    value: PropTypes.string,
  }))
};

export default connect(({ workflow }) => ({
  values: workflow.data.engineNotStartedValues
}), {})(MainEngineNotStarted);



// WEBPACK FOOTER //
// ./src/screens/shared/MainEngineNotStarted/MainEngineNotStarted.js